import React, { ReactNode } from "react";
import { reduce } from "ramda";

function noop() {
  return;
}

export function noopWhenDisabled(
  // tslint:disable-next-line: no-any
  handler: (...args: any[]) => void,
  disabled: boolean
) {
  return disabled ? noop : handler;
}

export function stringToMultiline(str: string) {
  const lines = str.split("\n");
  let lineCount = 0;
  // Do a join by reducing and pushing both the line and a br
  return reduce(
    (combinedLines, line: string) => {
      combinedLines.push(line.trim(), <br key={`br-${lineCount++}`} />);
      return combinedLines;
    },
    [] as ReactNode[],
    lines
  );
}
